import { conditionalAdminLayoutWrap } from '@middlewares';

import { Flag } from '@utils';
// import { IdentitiesPage } from '@pages/IdentitiesPage'; // TODO: remove this file in future

import UsersPage from './pages/UsersPage';
import UsersPagePaginated from './pages/UsersPagePaginated';

export const routes = {
  Identities: {
    label: 'Identities',
    path: '/identities',
    page: conditionalAdminLayoutWrap(<UsersPagePaginated />, <UsersPage />, Flag.IDENTITIES_PAGE_V2_WITH_PAGINATION),
  },
};
